import * as types from 'misc/types';
import * as actions from 'misc/actions';

const verifications = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_VERIFICATIONS.REQUEST:
            return actions.load(state);
        case types.SAGA_VERIFICATIONS.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_VERIFICATIONS.FAILURE:
            return actions.error(state, action.error);
        default:
            return state;
    }
};

export default verifications;



// WEBPACK FOOTER //
// ./src/reducers/verifications.js